import { NgModule } from '@angular/core';
import { DefaultFallbackStrategy, DefaultInterceptor, DefaultMissingHandler, DefaultTranspiler, TRANSLOCO_CONFIG, TRANSLOCO_FALLBACK_STRATEGY, TRANSLOCO_INTERCEPTOR, TRANSLOCO_LOADER, TRANSLOCO_MISSING_HANDLER, TRANSLOCO_TRANSPILER, TranslocoModule, translocoConfig } from '@jsverse/transloco';
import { environment } from '../../environments/environment';
import { HttpLoader } from './http.loader';

@NgModule({
  imports: [TranslocoModule],
  exports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: [
          { id: 'en', label: 'english' },
          { id: 'de', label: 'deutsch' },
          { id: 'it', label: 'italiano' },
        ],
        defaultLang: 'en',
        fallbackLang: 'en',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: environment.production,
        flatten: {
          aot: environment.production,
        },
        missingHandler: {
          useFallbackTranslation: true,
          logMissingKey: !environment.production,
        },
      }),
    },
    { provide: TRANSLOCO_LOADER, useClass: HttpLoader },
    { provide: TRANSLOCO_TRANSPILER, useClass: DefaultTranspiler },
    { provide: TRANSLOCO_INTERCEPTOR, useClass: DefaultInterceptor },
    { provide: TRANSLOCO_FALLBACK_STRATEGY, useClass: DefaultFallbackStrategy },
    { provide: TRANSLOCO_MISSING_HANDLER, useClass: DefaultMissingHandler },
  ],
})
export class TranslocoRootModule { }
